/*
成员        说明            类型        默认值
min       最小值         Number      -Infinity
max       最大值         Number      Infinity
value     当前值         Number
step      每次改变步数，可以为小数  Number or String  1
defaultValue  初始值         Number
disabled    禁用            Boolean     false
size      输入框大小       String      无
 */
import React from 'react';
import { findDOMNode } from 'react-dom';
import { InputNumber as AntdInputNumber, Icon } from 'antd';
import Label from './label';
import text from './text';
import { getPredicateValue, getRoundValue } from '../../helpers/util';
import KeyboardInputNumber from '../common/KeyboardInputNumber';

let InputNumber = null;

export default class InputNumberControl extends React.Component {
  constructor(props) {
    super(props);
    InputNumber = cb.electron.getSharedObject() && cb.rest.terminalType === 2 ? KeyboardInputNumber : AntdInputNumber;
    let { iNumPoint, cFormatData, cStyle, bIsNull, bHidden } = props;
    if (cb.utils.isEmpty(iNumPoint))
      iNumPoint = 2;
    let format = {}, config = null;
    if (cFormatData) {
      try {
        format = JSON.parse(cFormatData);
      } catch (e) { }
    }
    if (cStyle) {
      try {
        config = JSON.parse(cStyle);
      } catch (e) { }
    }
    // format 配置参数
    // format.splitter =true
    // format.before ='before'
    // format.after ='after'
    this.state = Object.assign({
      bIsNull,
      value: this.props.defaultValue,
      // min: -999999999,
      // max: 999999999,
      iNumPoint,
      disabled: false,
      visible: !bHidden,
      size: 'default',
      err: '',
      msg: '',
      focused: false,
      className: props.className || '',
      format
    }, config);
  }
  componentDidMount() {
    if (this.props.model)
      this.props.model.addListener(this);
    if (this.props.focus) {
      let input = cb.dom(findDOMNode(this.refs.input)).find('input');
      input.length && input[0].focus();
    }
  }
  componentDidUpdate() {
    if (this.props.model)
      this.props.model.addListener(this);
    // if (this.props.focus) {
    //   let input = cb.dom(findDOMNode(this.refs.input)).find('input');
    //   // input.length && input[0].focus();
    // }
  }
  componentWillUnmount() {
    if (this.props.model)
      this.props.model.removeListener(this);
  }
  componentWillUpdate(nextProps, nextState) {
    if (this.state.focused != nextState.focused && nextState.focused) {
      if (this.refs.input && this.refs.input.refs) {
        setTimeout(() => {
          let input = cb.dom(findDOMNode(this.refs.input)).find('input');
          if (input.length) {
            input[0].focus();
            input[0].setSelectionRange(0, input[0].value.length);
          }
        }, 0)
      }
    }
  }
  setListenerState(params) {
    const controlType = this.props.cControlType && this.props.cControlType.trim().toLocaleLowerCase();
    const { format } = this.state;
    let { iNumPoint } = params;
    switch (controlType) {
      case 'money':
        iNumPoint = cb.rest.AppContext.option ? cb.rest.AppContext.option.amountofdecimal : 0;
        break;
      case 'price':
        iNumPoint = cb.rest.AppContext.option ? cb.rest.AppContext.option.monovalentdecimal : 0;
        break;
    }
    if (format && format.decimal)
      iNumPoint = getPredicateValue(format.decimal);
    if(controlType==='money' || (format && format.decimal && format.decimal.indexOf("amountofdecimal"))){
      params.format={"splitter":true}
    }
    if (!cb.utils.isEmpty(iNumPoint))
      params.iNumPoint = iNumPoint;
    this.setState(params);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.model) return;
    if (nextProps.defaultValue != this.state.value)
      this.setState({ value: nextProps.defaultValue });
    if (nextProps.err != this.state.err)
      this.setState({ err: nextProps.err })
  }
  handleInputBlur(e) {
    // if (this.props.model)
    //   this.props.model.execute('blur');
    let { value } = this.state;
    value = cb.utils.isEmpty(value) ? null : value;
    if (this.props.model) {
      this.props.model.setValue(value, true);
      this.props.model.execute('blur');
    }
    this.setState({ focused: false });
  }
  handleInputFocus(e) {
    const target = e.target;
    setTimeout(() => {
      target.setSelectionRange(0, target.value.length);
    }, 0);
    this.setState({ focused: true });
  }
  onKeyDown = (e) => {
    if (e.keyCode !== 13) return;
    this.onPressEnter();
  }
  isNotCompleteNumber(num) {
    return isNaN(num) || num === '' || num === null || num && num.toString().indexOf('.') === num.toString().length - 1;
  }
  onPressEnter() {
    let { value } = this.state;
    value = this.isNotCompleteNumber(parseFloat(value, 10)) ? null : parseFloat(value, 10)
    if (this.props.model) {
      this.props.model.setValue(value, true, true);
      this.props.model.execute('enter');
    }
  }
  onChange(value) {
    // value = cb.utils.isEmpty(value) ? null : value;
    // if (this.props.model)
    //   this.props.model.setValue(value, true);
    let input = cb.dom(findDOMNode(this.refs.input)).find('input');
    if (input[0].value === '-0') {
      this.setState({ value: '-0' });
      return false
    }
    if (value === -0)
      value = 1 / value < 0 ? '-0' : '0';
    this.setState({ value });
  }
  validate(val) {
    this.setState({
      err: 'has-feedback has-' + val.type,
      msg: val.message
    });
  }
  baseControl() {
    const { format, iNumPoint, style, placeholder, before,after, bottom, showReset } = this.state;
    let showValue = this.state.value;
    let formatter = undefined;
    let parser = undefined;
    if (!cb.utils.isEmpty(showValue) && !isNaN(showValue) && iNumPoint != null)
      showValue = getRoundValue(Number(showValue), iNumPoint);
    if (format) {
      if (cb.utils.isEmpty(showValue))
        showValue = '';
      if (format.before)
        showValue = format.before + showValue;
      if (format.after)
        showValue += format.after;;
      if (format.splitter) {
        formatter = value =>{
          let _value = (value+'');
          let _valueArr = _value.split('.');
          if(_valueArr.length==1){
            return `${format.before || ''}${_value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${format.after || ''}`;
          }else{
            _valueArr[0] = _valueArr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return `${format.before || ''}${_valueArr.join('.')}${format.after || ''}`;
          }
        }
        parser = value => (value+'').replace(new RegExp((format.before || '') + "\\$\\s?|(,*)" + (format.after || ''), 'g'), '')
      } else if (format.before || format.after) {
        formatter = value => `${format.before || ''}${value}${format.after || ''}`;
        parser = value => (value+'').replace(new RegExp((format.before || '') + (format.after || ''), 'g'), '')
      }
    }
    let textCom = format && (format.splitter||format.before ||format.after) ? text(formatter(showValue)):text(showValue);
    const extraProps = {};
    if (style) {
      textCom = <div className='input-number-has-config-style' style={style}>{textCom}</div>
      extraProps.style = style;
    }
    const com = this.state.readOnly ? textCom : <InputNumber {...extraProps} placeholder={placeholder} formatter={formatter} parser={parser} ref="input" min={this.state.min} max={this.state.max} precision={iNumPoint} disabled={this.state.disabled} size={this.state.size} value={this.state.value} onFocus={e => this.handleInputFocus(e)} onBlur={e => this.handleInputBlur(e)} onChange={e => this.onChange(e)} onKeyDown={this.onKeyDown} onPressEnter={() => this.onPressEnter()} showReset={showReset} />
    if (!before &&!after && !bottom)
      return com;
    return (
      <div>
        <div className='control-flex'>
          {before && <span className="input-before">{before}</span>}
          {com}
          {after && <span className="input-after">{after}</span>}
        </div>
        {bottom && <div>{bottom}</div>}
      </div>
    );
  }
  relatedControl() {
    const control = this.baseControl();
    const { relatedControl } = this.props;
    if (!relatedControl)
      return control;
    return (
      <div className='has-related'>
        <div className='viewCell'>{control}</div>
        {relatedControl}
      </div>
    );
  }
  getControl() {
    let { readOnly, bIsNull } = this.state;
    let cShowCaption = this.props.cShowCaption;
    if(cShowCaption && cShowCaption != this.state.cShowCaption) cShowCaption = this.state.cShowCaption;
    const title = !readOnly && bIsNull === false && cShowCaption ? <label><Icon type='star' />{cShowCaption}</label> : <label>{cShowCaption}</label>;
    let control = (cShowCaption ? <Label control={this.relatedControl()} title={title} /> : this.relatedControl());
    return control;
  }
  render() {
    const control = this.getControl();
    let style = this.state.visible ? {} : { display: "none" };
    let className = this.state.err + ' ' + this.state.className +' '+ (this.state.classname ? `${this.state.classname} ` : '');
    return (
      <div style={style} className={className}>
        {control}
        <div className="ant-form-explain">{this.state.msg}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/inputnumber.jsx